import { createLucideIcon } from 'lucide-react'

const SquareText = createLucideIcon('square-text', [
  ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2' }],
  ['path', { d: 'M7 8h8' }],
  ['path', { d: 'M7 12h10' }],
  ['path', { d: 'M7 16h6' }]
])

export default SquareText
